import React, { Component }  from 'react';
import Modal from '../../../components/Modal';
import { connect } from 'react-redux';
import { PulseLoader } from 'react-spinners'; // <86111> ivelasquez 12/03/2021
import {fetchDetalleFacturas, fetchProformas, postInmatriculacionCorreo} from "../../../actions";
import {withRouter} from "react-router-dom";
import {getPedidosFacturacion2} from "../../../utils/getPedidosFacturacion";
import moment from "moment";
import {displayValidationErrors, isFormValid, resetValidators,updateValidators} from "../../../utils/validateForm";
import {WithContext as ReactTags} from "react-tag-input";
import correoValidators from "../../Inmatriculacion/correoValidators";
import Alert from "../../../components/Alert";


const emailRegEx = /^(([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+)(([\s]*[;,]+[\s]*(([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+))*)$/;

class CorreoPedidos extends Component {

    constructor(props) {
        super(props);

        this.handleDelete = this.handleDelete.bind(this);
        //this.handleAddition = this.handleAddition.bind(this); // <86111> ivelasquez 12/03/2021
        this.handleDrag = this.handleDrag.bind(this);
        this.handleTagClick = this.handleTagClick.bind(this);
        this.handleDeleteCopia = this.handleDeleteCopia.bind(this);
        this.handleAdditionCopia = this.handleAdditionCopia.bind(this);
        this.handleDragCopia = this.handleDragCopia.bind(this);
        this.enviarCorreoIntern = this.enviarCorreoIntern.bind(this);
        this.onChangeComentarioInput = this.onChangeComentarioInput.bind(this);
        this.onChangeValue = this.onChangeValue.bind(this);
        this.enviarCorreo = this.enviarCorreo.bind(this);
        this.handleInputBlur = this.handleInputBlur.bind(this); // <86111> ivelasquez 12/03/2021
        /*Inicio Req 92528 ebarboza 27 08 2021 */
        this.copiarPortaPapeles = this.copiarPortaPapeles.bind(this)
        this.copiarPortaPapelesAdd = this.copiarPortaPapelesAdd.bind(this)
        /*Fin Req 92528 ebarboza 27 08 2021 */
        this.validators = correoValidators;

        this.state = {
            numFichaVta: props.fdvID,
            pedidosArray: props.pedidosConCheck,
            pedidosXProforma: [],
            numProfVeh: '',
            pedidosArray2: [],
            registroCorreo:[],
            registroReponse: {itemList: null, numerodePaginas: 0},
            comentario: '',
            enviarPdf: true,//Req 92528 ebarboza 27082021
            enviarXml: true,
            tags: [],
            copia: [],
            suggestions: [],
            isFormValided: false,
            isOpen: true,

            muestraLoad: 'none',
            mensajeAlert: '',
            colorBackground: '#fcbc61',
            iconAlert: 'ion-alert-circled',

            alertErrorOpen: false,
            alertErrorMessage: '',
            alertSuccessOpen: false,
            alertSuccessMessage: '',
            envioMasivo: false, // <86111> ivelasquez 12/03/2021
            listaCorreos:props.listaCorreos //Req 92528 ebarboza 30 08 2021
        };

    }

    componentDidMount() {
        /*Inicio Req 92528 ebarboza 30 08 2021 */
        console.log('Lista de Correos:>> ',this.state.listaCorreos)
        let tags = []
        this.state.listaCorreos.map((correo,index) =>{ 
            if(correo){
                tags = [...tags, {id: index, text: correo.correosFichaVenta}]   
            }                
        })    
        this.setState({tags:tags})
        /*Fin Req 92528 ebarboza 30 08 2021 */

        resetValidators(this.validators);
        var dataRows = [];
        var emailList = [];

        this.props.fetchProformas(this.state.numFichaVta).then((result) => {
            result.payload.data.proformaExistenteList.forEach(obj => {

                this.setState({
                    proformasArray: [{
                        'numProfVeh': [obj.numProfVeh]
                    }]
                });

                getPedidosFacturacion2(this.state.numFichaVta, this.state.proformasArray)
                    .then((result) => {
                        result.forEach(item => {
                            this.setState({
                                pedidosXProforma: item[obj.numProfVeh]
                            });

                            this.state.pedidosXProforma.forEach(pxp => {
                                //this.state.pedidosArray.forEach(numPedidoVeh => {
                                    //if(pxp.numPedidoVeh === numPedidoVeh){
                                        const array = {
                                            codCompania: pxp.codCia,
                                            codOficinaRegistral: null,
                                            codPropietario: null,
                                            codProveedor: pxp.codProv,
                                            correo: null,
                                            desCliente: pxp.desClie,
                                            error: null,
                                            estadoPedido: pxp.estadoPedido,
                                            fechaCarga: pxp.fechaCargaTitulo,
                                            fechaTitulo: pxp.fechaTitulo,
                                            numChasis: pxp.numChasis,
                                            numPedidoVeh: pxp.numPedidoVeh,
                                            numPlaca: null,
                                            oficinaRegistral: null,
                                            situacionInmatriculacion: null,
                                            titulo: pxp.numTitulo
                                        };
                                        //this.state.registroCorreo.push(array)

                                this.state.pedidosArray.forEach(numPedidoVeh => {
                                    if(array.numPedidoVeh === numPedidoVeh) {
                                        this.state.registroCorreo.push(array);
                                    }
                                })
                            });
                        });
                    }).catch((error) => {
                    console.log(error);
                });
            })
        })
    };

    closeModal = () => {
        this.setState({isOpen: false});


    };
    /*Inicio Req 92528 ebarboza 27 08 2021 */
    copiarPortaPapeles = (e) => {
        if (!emailRegEx.test(e)) {
            let data = {'target': {value: ''}};
            this.handleInputChange(data, 'tags');
            return;
        }
        let tags = this.state.tags.filter(tag => {return tag.text != e})
        tags = [...tags, {id: tags.length + 1, text: e}]
        this.setState({tags: tags});      
     }

     copiarPortaPapelesAdd = (e) => {
        if (!emailRegEx.test(e)) {
            let data = {'target': {value: ''}};
            this.handleInputChange(data, 'tags');
            return;
        }
        let copia = this.state.copia.filter(copia => {return copia.text != e})
        copia = [...copia, {id: copia.length + 1, text: e}]
        this.setState({copia: copia});      
     }
    /*Fin Req 92528 ebarboza 27 08 2021 */
    showError(mensaje) {
        this.setState({
            muestraLoad: 'none',
            iconAlert: 'ion-close-circled',
            colorBackground: '#F56669',
            mensajeAlert: mensaje
        });
    };

    handleDelete(i) {
        this.setState({
            tags: this.state.tags.filter((tag, index) => index !== i),
        });
        let data = {'target': {value: ''}};
        if ((this.state.tags.length - 1) !== 0) {
            data = {'target': {value: 'test'}};
        }
        this.handleInputChange(data, 'tags');
    };
    // <I 86111> ivelasquez 12/03/2021
    /*handleAddition(tag) {
        if (!emailRegEx.test(tag)) {
            let data = {'target': {value: ''}};
            this.handleInputChange(data, 'tags');
            return;
        }

        let {tags} = this.state;
        this.setState({tags: [...tags, {id: tags.length + 1, text: tag}]});
        let data = {'target': {value: tag}};
        this.handleInputChange(data, 'tags');
    }*/

    handleInputBlur(tag) {
        if (!emailRegEx.test(tag)) {
            let data = {'target': {value: ''}};
            this.handleInputChange(data, 'tags');
            return;
        }

        let {tags} = this.state;
        this.setState({tags: [...tags, {id: tags.length + 1, text: tag}]});
        let data = {'target': {value: tag}};
        this.handleInputChange(data, 'tags');
    }
    // <F 86111> ivelasquez 12/03/2021
    handleDrag(tag, currPos, newPos) {
        const tags = [...this.state.tags];

        // mutate array
        tags.splice(currPos, 1);
        tags.splice(newPos, 0, tag);

        // re-render
        this.setState({tags});
    };

    handleTagClick(index) {
        console.log('The tag at index ' + index + ' was clicked');
    };

    handleDeleteCopia(i) {
        this.setState({
            copia: this.state.copia.filter((tag, index) => index !== i),
        });
    };

    handleAdditionCopia(tag) {
        // <I 86111> ivelasquez 12/03/2021
        if (!emailRegEx.test(tag)) {
            let data = {'target': {value: ''}};
            this.handleInputChange(data, 'copia');
            return;
        }
        // <F 86111> ivelasquez 12/03/2021
        let {copia} = this.state;
        this.setState({copia: [...copia, {id: copia.length + 1, text: tag}]});
    };

    handleDragCopia(tag, currPos, newPos) {
        const tags = [...this.state.copia];

        // mutate array
        tags.splice(currPos, 1);
        tags.splice(newPos, 0, tag);

        // re-render
        this.setState({tags});
    };

    showAlert = (alertType) => {
        this.setState({ [alertType]: true });
        setTimeout(() => this.setState({ [alertType]: false }), 5000);
    }

    openAlert = (data) => {
        if (data.estadoTrama === '0') {
            this.setState({ alertErrorMessage: data.mensaje });
            this.showAlert('alertErrorOpen');
        } else if (data.estadoTrama === '1') {
            this.setState({ alertSuccessMessage: data.mensaje });
            this.showAlert('alertSuccessOpen');
        } else {
            this.setState({ alertErrorMessage: `Hubo un error con el servicio ${data.estadoTrama}` });
            this.showAlert('alertErrorOpen');
        }
    }

    enviarCorreo(value) {
        this.setState({
            muestraLoad: 'block',
            closeModal: false,
        });
        let destinatario = [];
        let copias = [];
        value.destinatario && value.destinatario.forEach((item) => {
            destinatario.push(item.text);
        });
        value.copia && value.copia.forEach((item) => {
            copias.push(item.text);
        });

        let dataEnviar = [];
        if (value.item && value.item.fechaTitulo) {
            if (value.item.fechaTitulo && value.item.fechaTitulo.toString().indexOf('/') === -1) {
                let fecha = new Date(value.item.fechaTitulo);
                fecha = moment(fecha, 'DD/MM/YYYY').format("DD/MM/YYYY");
                value.item.fechaTitulo = fecha;
            }
            dataEnviar = [value.item];
        } else {
            if (value.item) {
                dataEnviar = [value.item];
                value.item = null;
            } else {
                const {dataRows} = this.state;
                dataRows.forEach((item) => {
                    let fecha = new Date(item.fechaTitulo);
                    fecha = moment(fecha, 'DD/MM/YYYY').format("DD/MM/YYYY");
                    item.fechaTitulo = fecha;
                });
                dataEnviar = dataRows;
            }
        }

        this.props.postInmatriculacionCorreo({
            'items': dataEnviar,
            'destinatario': destinatario,
            'copias': copias,
            'mensaje': value.mensaje,
            'enviarXml': value.enviarXml,
            'enviarPdf': value.enviarPdf,
            // <I 86111> ivelasquez 12/03/2021
            'tipoCorreo': value.tipoCorreo,
            'numFichaVtaVeh': value.numFichaVtaVeh
            // <F 86111> ivelasquez 12/03/2021
        }).then((result) => {
            if (result.payload.data.estadoTrama === '1') {
                // <I 86111> ivelasquez 12/03/2021
                this.props.changeIndex(1);
                //this.closeModal();
                this.props.closeModal();
                if (document.getElementById('checkBoxAll').checked)
                    document.getElementById('checkBoxAll').click();
                this.props.fnUnSelectedAll();
                this.openAlert(result.payload.data);
                this.setState({registros: [], dataRows: [], selectedID: []});
                /*this.setState({
                    closeModal: false,
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#1DB89B',
                    mensajeAlert: 'Se Ejecuto Correctamente'
                });*/
                this.initPaginacion(0, 0);
                //document.getElementById('checkBoxAll').checked = false;
                // <F 86111> ivelasquez 12/03/2021
            } else {
                // <I 86111> ivelasquez 12/03/2021
                //this.closeModal();
                this.props.closeModal();
                this.props.fnUnSelectedAll();
                // <F 86111> ivelasquez 12/03/2021
                this.openAlert(result.payload.data);
                /*this.setState({
                    muestraLoad: 'none',
                    selectedID: [],
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: `¡Error interno del servidor: ${result.payload.data.mensaje}!`
                });*/
            }
            this.setState({selectRow: null});
        }).catch((error) => {
            this.setState({selectRow: null, selectedID: []});
            this.setState({
                muestraLoad: 'none',
                iconAlert: 'ion-close-circled',
                colorBackground: '#F56669',
                mensajeAlert: '¡Error interno del servidor!'
            });
        });
    };
    // <I 86111> ivelasquez 12/03/2021
    enviarCorreoMasivo(value) {
        this.setState({
            muestraLoad: 'block',
            closeModal: false,
        });
        let destinatario = [];
        let copias = [];
        value.destinatario && value.destinatario.forEach((item) => {
            destinatario.push(item.text);
        });
        value.copia && value.copia.forEach((item) => {
            copias.push(item.text);
        });

        let dataEnviar = [];
        value.items.forEach((item) => {
            if (item && item.fechaTitulo) {
                if (item.fechaTitulo && item.fechaTitulo.toString().indexOf('/') === -1) {
                    let fecha = new Date(item.fechaTitulo);
                    fecha = moment(fecha, 'DD/MM/YYYY').format("DD/MM/YYYY");
                    item.fechaTitulo = fecha;
                }
            }
        })
        dataEnviar = value.items;

        this.props.postInmatriculacionCorreo({
            'items': dataEnviar,
            'destinatario': destinatario,
            'copias': copias,
            'mensaje': value.mensaje,
            'enviarXml': value.enviarXml,
            'enviarPdf': value.enviarPdf,
            'tipoCorreo': value.tipoCorreo,
            'numFichaVtaVeh': value.numFichaVtaVeh,
            "envioMasivo": value.envioMasivo
        }).then((result) => {
            if (result.payload.data.estadoTrama === '1') {
                this.props.changeIndex(1);
                //this.closeModal();
                this.props.closeModal();
                if (document.getElementById('checkBoxAll').checked)
                    document.getElementById('checkBoxAll').click();
                this.props.fnUnSelectedAll();
                this.openAlert(result.payload.data);
                this.setState({registros: [], dataRows: [], selectedID: []});
                /*this.setState({
                    closeModal: false,
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#1DB89B',
                    mensajeAlert: 'Se Ejecuto Correctamente'
                });*/
                this.initPaginacion(0, 0);
                //document.getElementById('checkBoxAll').checked = false;
            } else {
                this.props.closeModal();
                this.props.fnUnSelectedAll();
                this.openAlert(result.payload.data);

                /*this.setState({
                    muestraLoad: 'none',
                    selectedID: [],
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: `¡Error interno del servidor: ${result.payload.data.mensaje}!`
                });*/
            }
            this.setState({selectRow: null});
        }).catch((error) => {
            this.setState({selectRow: null, selectedID: []});
            this.setState({
                muestraLoad: 'none',
                iconAlert: 'ion-close-circled',
                colorBackground: '#F56669',
                mensajeAlert: '¡Error interno del servidor!'
            });
        });
    };
    // <F 86111> ivelasquez 12/03/2021

    enviarCorreoIntern = () => {
        if (this.state.isFormValided || this.state.tags.length > 0) {
            // <I 86111> ivelasquez 12/03/2021
            if (this.state.envioMasivo)
                this.enviarCorreoMasivo({
                    mensaje: this.state.comentario,
                    destinatario: this.state.tags,
                    copia: this.state.copia,
                    items: this.state.registroCorreo,
                    enviarXml: this.state.enviarXml,
                    enviarPdf: this.state.enviarPdf,
                    tipoCorreo: 'facturacionFN',
                    numFichaVtaVeh: this.state.numFichaVta,
                    envioMasivo: true
                })
            else
                // <F 86111> ivelasquez 12/03/2021
                this.state.registroCorreo.forEach(obj => {
                    this.enviarCorreo({
                        mensaje: this.state.comentario,
                        destinatario: this.state.tags,
                        copia: this.state.copia,
                        item: obj,
                        enviarXml: this.state.enviarXml,
                        enviarPdf: this.state.enviarPdf,
                        // <I 86111> ivelasquez 12/03/2021
                        tipoCorreo: 'facturacionFN',
                        numFichaVtaVeh: this.state.numFichaVta
                        // <F 86111> ivelasquez 12/03/2021
                    })
                });

            /*this.enviarCorreo(
                {
                    mensaje: this.state.comentario,
                    destinatario: this.state.tags,
                    copia: this.state.copia,
                    item: this.state.registroCorreo,
                    enviarXml: this.state.enviarXml,
                    enviarPdf: this.state.enviarPdf
                })*/
        }
    };

    onChangeFormValidation = () => {
        this.setState({isFormValided: isFormValid(this.validators)});
    };

    onChangeValue = e => {
        this.setState({[e.target.name]: e.target.checked})
    };

    handleInputChange = (e, field, exclude) => {
        const validator = this.validators[field];
        if(validator) {
            validator.state = (e !== null && !exclude ? e.target.value : '');
            validator.exclude = (typeof(exclude) === 'undefined' || exclude === null ? false : exclude);
            this.onChangeFormValidation();
        }
    };

    onChangeComentarioInput(e) {
        this.setState({comentario: e.target.value});
        this.handleInputChange(e, 'comentario');
    };


    render() {
        const {tags, copia, suggestions} = this.state;
        const DefaultClassNames = {
            tag: "pill pill-cyan pillSelct-pills-item ng-binding ng-scope",
        };

        return(

            <div>
                {this.state.isOpen === true &&
                <div>
                    <Modal modalSize='modal-dialog' title='Enviar Correo'
                           closeModal={this.props.closeModal}
                           isOpen
                    >
                        <div>
                            <div className='form-group'>
                                <label className='labelInfo'> Correos</label>
                                <ReactTags
                                    tags={tags}
                                    placeholder={"Ingrese un correo"}
                                    suggestions={suggestions}
                                    classNames={DefaultClassNames}
                                    handleDelete={this.handleDelete}
                                    handleInputBlur={this.handleInputBlur} // <86111> ivelasquez 12/03/2021
                                    handleAddition = {e => this.copiarPortaPapeles(e)} // Req 92528 ebarboza 27 08 2021
                                    handleDrag={this.handleDrag}
                                    handleTagClick={this.handleTagClick}
                                    autofocus={true} // <86111> ivelasquez 12/03/2021
                                />
                                {this.state.tags.length > 0?null:displayValidationErrors(this.validators, 'tags')}
                            </div>
                            <div className='form-group'>
                                {/* <I 86111> ivelasquez 12/03/2021 */}
                                <div className='row'>
                                    <div className='col-md-8'>
                                        {/* <F 86111> ivelasquez 19/02/2021 */}
                                        <label className='labelInfo'> Correos Adicionales</label>
                                        <ReactTags
                                            tags={copia}
                                            suggestions={suggestions}
                                            placeholder={"Ingrese un correo"}
                                            classNames={DefaultClassNames}
                                            handleDelete={this.handleDeleteCopia}
                                            handleInputBlur={this.handleAdditionCopia} // <86111> ivelasquez 12/03/2021
                                            handleAddition = {e => this.copiarPortaPapelesAdd(e)} // Req 92528 ebarboza 27 08 2021
                                            handleDrag={this.handleDragCopia}
                                            handleTagClick={this.handleTagClick}
                                            autofocus={false} // <86111> ivelasquez 12/03/2021
                                        />
                                        {/* <I 86111> ivelasquez 12/03/2021 */}
                                    </div>
                                    <div className='col-md-4'>
                                        <label></label>
                                        <div>
                                            <label>Envío Masivo &nbsp;</label>
                                            <input type="checkbox" checked={this.state.envioMasivo}
                                                   onChange={this.onChangeValue}
                                                   name="envioMasivo"
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* <F 86111> ivelasquez 12/03/2021 */}
                            </div>
                            <div className='form-group'>
                                <label className='labelInfo'>Texto Correo
                                </label>
                                <textarea
                                    className='form-control' value={this.state.comentario}
                                    onChange={this.onChangeComentarioInput}
                                    placeholder='Ingresa tus comentarios acá'
                                />
                            </div>
                            <div className='form-group'>
                                <label className='labelInfo'>Adjuntar</label>
                                <div className='col-md-10'>
                                    <div className='col-md-4'>
                                        <label>XML &nbsp;</label> {/* <86111> ivelasquez 12/03/2021 */}
                                        <input type="checkbox" disabled={false} readOnly={false} // <86111> ivelasquez 12/03/2021
                                               onChange={this.onChangeValue}
                                               checked={this.state.enviarXml}
                                               name="enviarXml"
                                        />
                                    </div>
                                    <div className='col-md-4'>
                                        <label>PDF&nbsp;</label> {/* <86111> ivelasquez 12/03/2021 */}
                                        <input type="checkbox" disabled={false} readOnly={false}  checked={this.state.enviarPdf}
                                               onChange={this.onChangeValue}
                                               name="enviarPdf"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='modal-actions'>
                            <button className='btn btn-primary pull-right'
                                    onClick={() => this.enviarCorreoIntern()}>Enviar
                            </button>
                        </div>
                    </Modal>
                    <div className='modal extraFilter' role='dialog' data-backdrop='static'
                         style={{zIndex: '2000', display: this.state.muestraLoad}}>
                        {/* <I 86111> ivelasquez 12/03/2021 */}
                        <div className='modal-dialog modal-sm loading' role='document'>
                            <PulseLoader color='#F8A14A' size={20} margin='10px' loading={true} />
                        </div>
                        {/* <F 86111> ivelasquez 05/03/2021 */}
                    </div>
                </div>
                }
                {
                    this.state.alertErrorOpen &&
                    <Alert type='alert-danger' icon='ion-alert-circled' closeAlert={this.closeAlertError}>
                        <p>{this.state.alertErrorMessage}</p>
                    </Alert>
                }
                { this.state.alertSuccessOpen &&
                <Alert type='alert-success' icon='ion-checkmark-circled' >
                    <p>{this.state.alertSuccessMessage}</p>
                </Alert>
                }
            </div>
        )

    }

}


function mapStateToProps(state) {
    return {
    };
}

CorreoPedidos.defaultProps = {
    pedidosXProforma: [],
    muestraLoad: 'none',
}
export default withRouter (
    connect(
    mapStateToProps,
    { fetchProformas,
        fetchDetalleFacturas,
        postInmatriculacionCorreo}

)(CorreoPedidos));



// WEBPACK FOOTER //
// ./src/pages/modals/CorreoPedidos/index.js